export const iconFontAwesomeHandsThumbsDown = (
	<i className="fa-solid fa-thumbs-down"></i>
);
